import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseService } from "../_types/case-service";
import { firstValueFrom, Observable } from "rxjs";
import { TemplatesContractsService } from "../../templates/_services/templates-contracts.service";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "src/app/core/loader/loader.service";
import { DialogService } from "primeng/dynamicdialog";
import { TemplatesService } from "../../templates/_services/templates.service";
import { saveAs } from 'file-saver';


@Injectable({
    providedIn: 'root',
})
export class CasesServicesService extends Service<CaseService> {
    public override type = 'caseServices';
    public override url = 'attendance/caseServices';

    constructor(
        _http: HttpClient,
        _loaderService: LoaderService,
        private templatesContractsService:TemplatesContractsService,
        private dialogService: DialogService,
        private templateService: TemplatesService
    ){
        super(_http, _loaderService);
    }
 
    public generateJobsByTemplate(caseServiceId: string, rateTemplateId: string | null): Observable<any> {
        return this.http.get<any>(this.getAPIUrl()+"/"+caseServiceId+"/generateJobsByTemplate/"+rateTemplateId);
    }

    public async printVisitReport(caseServiceId: string, publicCase: boolean = false) {
        
        var caseService = await firstValueFrom( this.get(caseServiceId, {include: ['case']}));
        let contractId = caseService.case?.contractId;
       
        this.templateService.getTemplateId("VisitReport", contractId,caseService.case?.companyId, undefined, caseService.caseId, caseServiceId).then((result:any) => {
     
            if(result != null){
                let templateId = result.templateId;
                let url = this.getAPIUrl() + "/" + caseServiceId + "/pdf/" + templateId;
                console.log("URL Report", url);
                this.templateService.open(url, result.metadata);
            }
        });
    }

    

    public create(caseService: CaseService): Observable<CaseService[]> {
        return this.http.post<CaseService[]>(this.getAPIUrl() + '/create', caseService);
    }
    
    public checkIfOtherService(caseService: CaseService): Observable<CaseService[]> {
        return this.http.post<CaseService[]>(this.getAPIUrl() + '/checkIfOtherService', caseService);
    }

    public getOffTimeCount(): Observable<any> {
        let url = this.getAPIUrl() + '/offtime-count';
        this.loaderService.skipRequest(url);
        return this.http.get<any>(url);
    }

    public casesservicesPendingApprovalExcel(workerId: string | null, processorId: string | null, dateFrom: Date | null, dateTo: Date | null, createdAtFrom: Date | null, createdAtTo: Date | null, countryRegionId: string | null, zoneId: string | null, caseNumber: string | null, zipCode: string | null, city: string | null) {
        let url = this.getAPIUrl() + '/casesservices-pending-approval/excel?';
        if(workerId) url += `workerId=${workerId}&`;
        if(processorId) url += `processorId=${processorId}&`;
        if(dateFrom) url += `dateFrom=${encodeURIComponent(dateFrom.toISOString())}&`;
        if(dateTo) url += `dateTo=${encodeURIComponent(dateTo.toISOString())}&`;
        if(createdAtFrom) url += `createdAtFrom=${encodeURIComponent(createdAtFrom.toISOString())}&`;
        if(createdAtTo) url += `createdAtTo=${encodeURIComponent(createdAtTo.toISOString())}&`;
        if(countryRegionId) url += `countryRegionId=${countryRegionId}&`;
        if(zoneId) url += `zoneId=${zoneId}&`;
        if(caseNumber) url += `caseNumber=${caseNumber}&`;
        if(zipCode) url += `zipCode=${zipCode}&`;
        if(city) url += `city=${city}&`;

        return this.http.get(url, { responseType: 'blob' }).subscribe((response: Blob) => {
            // Usar FileSaver.js para guardar el archivo
            saveAs(response, ('servicios-pendientes.xlsx'));
        });
            
    }
}
